import { render } from "./aboutPage.vue?vue&type=template&id=36c404d6&scoped=true"
import script from "./aboutPage.vue?vue&type=script&lang=js"
export * from "./aboutPage.vue?vue&type=script&lang=js"

import "./aboutPage.vue?vue&type=style&index=0&id=36c404d6&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c404d6"]])

export default __exports__